import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'Attachments',
  props: ['propsData'],
  data: function () {
    return {
      data: {}, // { files: [ { id, name, seqId, deleted: false, file: {} } ], permissions: { add, delete, download, }, sort: false, download: function(id), mimeTypes: 'image/*,application/pdf,app/msword', multiple: false, maxFilesNumber: 3 },
      message: '',
      cntrlHelpTypes: [],
      cntrlItemHelp: '',
      files: null,
      file: '',
      showHelp: false,
      deleteItem: null,
      deleteItemIdx: null,
      showConfirmDelete: false
    }
  },
  created() {
    this.data = this.propsData;
    //console.log(this.propsData);
    this.$root.$on('control_help_updated', this.init);
  },
  computed: {
    attachments: function () {
      if (this.data.sort)
        return this.data.files.filter(i => !i.deleted).sort((obj1, obj2) => obj1.seqId - obj2.seqId);
      else
        return this.data.files.filter(i => !i.deleted);
    },
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.data = this.propsData;
        this.cntrlHelpTypes = this.data.cntrlItemsHelp;
      });
    },
    openHelp(cntrlName) {
      this.cntrlItemHelp = this.getCntrlDescription(cntrlName);
      if ((this.cntrlItemHelp) && (this.cntrlItemHelp.length > 0))
        this.showHelp = true;
    },
    closeHelp() {
      this.showHelp = false;
    },
    getCntrlDescription(name) {
      var cntrlHelpType = [];
      var sCntrlTooltip = '';

      if (this.cntrlHelpTypes && this.cntrlHelpTypes.length > 0) {
        cntrlHelpType = this.cntrlHelpTypes.filter(p => p.name == name);
        sCntrlTooltip = (cntrlHelpType.length > 0) ? cntrlHelpType[0].description : '';
      }

      return sCntrlTooltip;
    },
    getCntrlVisibility(name) {
      var cntrlHelpType = [];
      var sCntrlTooltip = '';

      if (this.cntrlHelpTypes && this.cntrlHelpTypes.length > 0) {
        cntrlHelpType = this.cntrlHelpTypes.filter(p => p.name == name);
        sCntrlTooltip = (cntrlHelpType.length > 0) ? cntrlHelpType[0].description : '';
      }

      return sCntrlTooltip.length > 0;
    },
    onSelected(e) {
      //console.log(e);
      this.files = e;
      this.add(); // selectedfile added to table automatically, comment out if user should press add button
    },
    add() {
      console.log("add")
      var deleted = 0;
      for (var i = 0; i < this.data.files.length; ++i)
        if (this.data.files[i].deleted)
          deleted++;

      for (var i = 0; i < this.files.length; ++i) {
        if (this.data.files.length - deleted < this.data.maxFilesNumber) {
          var f = this.files[i];
          var newSeqId = Math.max.apply(Math, this.data.files.map(function (o) { return o.seqId; })) + 1;

          //check for file size
          if (this.files[i].size < 3145728)
            this.data.files.push({
              id: -1,
              fileName: f.name,
              name: f.name,
              seqId: newSeqId,
              deleted: false,
              file: f
            });
          else {
            this.showMessage(this.$t('messages.AttachmentTooBig'), 2);
          }
        }
        else {
          this.message = 'Maximum number of attachments reached.';
          this.$notify({ duration: 10000, group: 'app', text: this.messages, type: 'warn' });
          break;
        }
      }

      //console.log(this.data.files);
      //console.log(this.attachments);
      this.files = null;
      setTimeout(function () { this.file = '';; }.bind(this), 200);
    },
    showDeleteConfirmDialog(item, idx) {
      this.deleteItem = item;
      this.deleteItemIdx = idx;
      this.showConfirmDelete = true;
    },
    deleteItemFun() {
      if (this.deleteItem.attachmentId == -1) {
        this.attachments.splice(this.deleteItemIdx, 1);
        this.data.files.splice(this.deleteItemIdx, 1);
        return;
      }

      this.$root.$emit('enable_disable_loader', true);
      axios.post('/ApplicationAttachment/DeleteAttachment', { value: this.deleteItem.attachmentId})
        .then(response => {
          if (response.data.data.status == 0) {
            this.showMessage(this.$t('messages.AttachmentDeletedSuccess'), 0);
            this.deleteItem.fileName = null;
            this.showConfirmDelete = false;
          }
          else
            this.showMessage(response.data.data.text, 1);
          this.$root.$emit('enable_disable_loader', false);
        })
        .catch(e => {
          this.$root.$emit('enable_disable_loader', false);
          console.log(e);
        })
    },
    download(id) {
      this.data.download(id);
    },
    onSelectedSingleAttachment(e, id) {      
      var fileUploaded = this.attachments.filter(item => item.attachmentId === id)[0];
      fileUploaded.file = e.currentTarget.files[0];
      this.uploadAttachment(fileUploaded);
    },
    addAttachment(item) {
      this.iCntrl = document.getElementById('upload' + item.attachmentId);
      this.iCntrl.click();
    },
    uploadAttachment(file2Upload) {
      var formData = new FormData();
      formData.append("attachmentId", file2Upload.attachmentId);
      formData.append("file", file2Upload.file);

      this.$root.$emit('enable_disable_loader', true);
      axios.post('/ApplicationAttachment/Update', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(response => {
          if (response.data.data.status == 0) {
            this.showMessage(this.$t('messages.AttachmentSavedSuccess'), 0);
            file2Upload.fileName = file2Upload.file.name;
            //this.checkMandatoryAttachments();
          }
          else
            this.showMessage(response.data.data.text, 1);
          this.$root.$emit('enable_disable_loader', false);
        })
        .catch(e => {
          this.$root.$emit('enable_disable_loader', false);
          console.log(e);
          //this.showMessage(e);
        })
    },
    showMessage(msg, type) {
      this.message = msg;
      if (type === 1)
        this.message += ' ' + this.$t('messages.ProblemPersistsContactSupport');
      this.$notify({ duration: 10000, group: 'app', text: msg, type: type == 1 ? 'warn' : type == 2 ? 'error' : type == 3 ? 'success' : '' }); // title: '',
    },
  }
}
